import {
  BatteryFeature,
  BloodPressureFeature,
  HeartRateFeature,
  TemperatureFeature,
} from '../../mock/index';
import Manager from '../../../strategy/Manager';
import BaseModel from '../../../model/BaseModel';
import MockModel from '../model/MockModel';

export default class MockSmartband implements Manager {
  private temperatureFeature = new TemperatureFeature();
  private heartRateFeature = new HeartRateFeature();
  private batteryFeature = new BatteryFeature();
  private bloodPressureFeature = new BloodPressureFeature();

  constructor(public macAddress: string) {
    this.macAddress = macAddress;
  }

  async connect(): Promise<any> {
    return new MockModel();
  }
  async disconnect(): Promise<any> {
    return new MockModel();
  }
  scan(): any[] {
    const mocks = [new MockModel(), new MockModel()];
    return mocks;
  }

  getTemperature(): BaseModel {
    return this.temperatureFeature.execute();
  }

  getHeartRate(): BaseModel {
    return this.heartRateFeature.execute();
  }

  getBatteryLevel(): BaseModel {
    return this.batteryFeature.execute();
  }

  getBloodPressure(): BaseModel {
    return this.bloodPressureFeature.execute();
  }
}
